import type { AvailableStartDateChoice } from '@/apply/answers';

export const US_TIMEZONE_OPTIONS = [
  { label: 'Eastern (ET)', value: 'America/New_York' },
  { label: 'Central (CT)', value: 'America/Chicago' },
  { label: 'Mountain (MT)', value: 'America/Denver' },
  { label: 'Mountain – no DST (MST)', value: 'America/Phoenix' },
  { label: 'Pacific (PT)', value: 'America/Los_Angeles' },
  { label: 'Alaska (AKT)', value: 'America/Anchorage' },
  { label: 'Hawaii (HT)', value: 'Pacific/Honolulu' },
];

export const SCORE_TICKS = [
  { align: 'left', label: 'score everything', value: 0 },
  { align: 'center', label: 'loose', value: 50 },
  { align: 'center', label: 'default', value: 85 },
  { align: 'right', label: 'strict', value: 100 },
] as const;

const HAIKU_4_5 = {
  label: 'Claude Haiku 4.5',
  value: 'claude-haiku-4-5-20251001',
};

const SONNET_4_6 = {
  label: 'Claude Sonnet 4.6',
  value: 'claude-sonnet-4-6',
};

const OPUS_4_7 = {
  label: 'Claude Opus 4.7',
  value: 'claude-opus-4-7',
};

const OPUS_4_8 = {
  label: 'Claude Opus 4.8',
  value: 'claude-opus-4-8',
};

export const SCORING_MODELS = [
  {
    ...HAIKU_4_5,
    label: `${HAIKU_4_5.label} (recommended)`,
  },
  SONNET_4_6,
  OPUS_4_7,
  OPUS_4_8,
];

export const TAILORING_MODELS = [
  HAIKU_4_5,
  {
    ...SONNET_4_6,
    label: `${SONNET_4_6.label} (recommended)`,
  },
  OPUS_4_7,
  OPUS_4_8,
];

export const AVAILABLE_START_DATE_OPTIONS: {
  label: string;
  value: AvailableStartDateChoice;
}[] = [
  { label: 'Today', value: 'today' },
  { label: '2 weeks from today', value: 'twoWeeks' },
];
